import { render } from "./BlockCollector.vue?vue&type=template&id=1441c14c"
import script from "./BlockCollector.vue?vue&type=script&lang=js"
export * from "./BlockCollector.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__